export * from './palette';
import { createTheme } from 'office-ui-fabric-react';
import palette from './palette';

const theme = createTheme({
  palette
});

export default theme;
